import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
import authReducer from 'Features/auth/reducer'
import userReducer from 'Features/user/reducer'
import uiReducer from 'Features/ui/reducer'
import fbReducer from './features/fb/reducer'
import orderReducer from './features/order/reducer'
import eventsReducer from './features/events/reducer'
import information from './features/informations/reducer'
import roomsReducer from './features/rooms/reducer'
import amenityServiceReducer from './features/amenityandservice/reducer'
import hotdeskReducer from './features/hotdesk/reducer'
import buildingReducer from './reducers/reducerBuilding'
import floorReducer from './reducers/reducerFloor'
import zoneReducer from './reducers/reducerZone'
import settingReducer from './reducers/reducerSetting'
import seatReducer from './reducers/reducerSeat'
import reducerDelete from './reducers/reducerDelete'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    auth: authReducer.authen,
    forgotPassword: authReducer.forgotPassword,
    resetPassword: authReducer.resetPassword,
    user: userReducer.user,
    users: userReducer.users,
    integration: userReducer.integration,
    ui: uiReducer,
    events: eventsReducer,
    orders: fbReducer.orders,
    ordersRoom: orderReducer.ordersRoom,
    roomsFavor: roomsReducer.roomsFavor,
    faq: information.faq,
    contact: information.contact,
    term: information.term,
    rooms: roomsReducer.rooms,
    o365Url: userReducer.o365Url,
    eventHome: eventsReducer.eventHome,
    eventList: eventsReducer.eventList,
    eventDetail: eventsReducer.eventDetail,
    room: roomsReducer.room,
    roomStatus: roomsReducer.roomStatus,
    roomsSuggest: roomsReducer.roomsSuggest,
    roomsSuggesttion: roomsReducer.roomsSuggesttion,
    foodActive: amenityServiceReducer.foodActive,
    foodPast: amenityServiceReducer.foodPast,
    foodNext: amenityServiceReducer.foodNext,
    orderFbsList: amenityServiceReducer.orderFbsList,
    orderInfoService: amenityServiceReducer.orderInfoService,
    setting: eventsReducer.setting,
    eventFullCalendar: eventsReducer.eventFullCalendar,
    eventTypeList: eventsReducer.eventTypeList,
    eventRoomFormat: eventsReducer.eventRoomFormat,
    timezone: information.timezone,
    urlGoogle: userReducer.urlGoogle,
    seatFavorite: hotdeskReducer.seatFavorite,
    buildings: buildingReducer.buildings,
    allfloor: floorReducer.allfloor,
    allzone: zoneReducer.allzone,
    suggestInformation: settingReducer.suggestInformation,
    seatsuggest: seatReducer.seatsuggest,
    eventSeatGroup: seatReducer.eventSeatGroup,
    myeventseat: seatReducer.myeventseat,
    eventSeatDelete: reducerDelete.eventSeatDelete,
    facilities: orderReducer.facilities,
    foodAndBev: orderReducer.foodAndBev,
    orderFacilities: orderReducer.orderFacilities,
    orderFoodAndBev: orderReducer.orderFoodAndBev,
    orderInfo: orderReducer.orderInfo,
    canBooking: roomsReducer.canBooking,
    changePasswordStatus: userReducer.changePasswordStatus,
    avaibleOrder: roomsReducer.avaibleOrder,
    eventDetailModal: roomsReducer.setEventDetailModal,
    conferenceTypeList: eventsReducer.conferenceTyleList,
    userGroups: userReducer.userGroups,
    attendeeCheckinList: eventsReducer.attendeeCheckinList,
    users_with_keyword: userReducer.users_with_keyword
})


// WEBPACK FOOTER //
// ./src/reducers.js